import { z } from 'zod';
import i18n from '../i18n';

const optionalPiva = z
  .string()
  .refine((v) => !v || /^\d{11}$/.test(v), { message: i18n.t('anagrafiche.val_anga.piva') })
  .optional();

export const intermediarioCreateSchema = z.object({
  ragione_sociale: z.string().min(1, i18n.t('anagrafiche.val_anga.ragione_sociale')),
  numero_iscrizione_anga: z.string().min(1, i18n.t('anagrafiche.val_anga.anga')),
  data_rilascio: z.string().min(1, i18n.t('anagrafiche.val_anga.data_rilascio')),
  categorie_classe: z.string().min(1, i18n.t('anagrafiche.val_anga.categorie')),
  piva: optionalPiva,
  referente: z.string().optional(),
  contatti: z.string().optional(),
});

export const intermediarioUpdateSchema = z.object({
  ragione_sociale: z.string().min(1, i18n.t('anagrafiche.val_anga.ragione_sociale')).optional(),
  numero_iscrizione_anga: z.string().min(1).optional(),
  data_rilascio: z.string().optional(),
  categorie_classe: z.string().min(1).optional(),
  piva: optionalPiva,
  referente: z.string().optional(),
  contatti: z.string().optional(),
});

export type IntermediarioCreateData = z.infer<typeof intermediarioCreateSchema>;
export type IntermediarioUpdateData = z.infer<typeof intermediarioUpdateSchema>;
